module.exports = __webpack_public_path__ + "static/Commerce-bceb08df06cbfe45fbbb1a09738e2113.png";